import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '../../../Icons/Close';
import { CommonProps } from '../../../interfaces/components';
import ReactPlayer from 'react-player';
import { disptchCTAClickObject } from '../../../Analytics';

const LaValleShopFromHome = ({ active, setActive }: CommonProps) => {
  const { t } = useTranslation();

  const onLearnMore = () => {
    const sfh_url = 'https://www.thebicestercollection.com/la-vallee-village/en/services/virtual-shopping';
    disptchCTAClickObject('lavallee', 'Button', 'ShopFromHome', 'Learn More', sfh_url);
    window.open(sfh_url, '_blank');
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding="0px"
        width={['100%', '100%', '710px', '710px']}
        height={['100%', '100%', '700px', '700px']}
        overflowY={['auto', 'auto', 'auto', 'hidden']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '35px']}
          right={['30px', '30px', '35px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box w="100%" h={['500px', '500px', '400px']}>
          {active && (
            <ReactPlayer
              progressInterval={1}
              height="inherit"
              width="inherit"
              loop={true}
              muted
              controls={false}
              playing={active}
              url="https://emperia-static.s3.eu-west-2.amazonaws.com/client/bister/lavalle/shop-from-home.mp4"
              playsinline
            />
          )}
        </Box>
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="8" mt="10" mb="8">
          <Text
            textAlign="center"
            fontWeight="400"
            fontFamily="SangBleuBPLight"
            fontSize={['16px', '16px', '18px', '20px', '20px']}
            mx="auto"
          >
            {t('lv_shop_from_home_title')}
          </Text>
          <Text
            fontWeight="400"
            fontSize={['14px', '14px', '16px', '16px', '16px']}
            lineHeight={['18px', '18px', '18px', '20px', '20px']}
            textAlign="center"
            className="copy"
            fontFamily="JosefinSans"
            whiteSpace="pre-line"
            maxW="85%"
          >
            {t('lv_shop_from_home_description')}
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection={['column', 'column', 'row']}
          gap="3"
          justifyContent="center"
          alignItems="center"
          pb={['10', '10', '0']}
        >
          <Button
            bg="white"
            border="1px solid gray"
            borderRadius="0px"
            h="46px"
            p="0px 40px"
            color="#455255"
            _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
            _active={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
            onClick={onLearnMore}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
              fontFamily="JosefinSans"
            >
              {t('lv_shop_from_home_btn')}
            </Text>
          </Button>

          {/* <Button
            bg="#C29F6B"
            color="white"
            borderRadius="0px"
            border="1px solid #C29F6B"
            w="100px"
            h="46px"
            _hover={{ bg: 'white', color: '#C29F6B' }}
            _active={{ bg: 'white', color: '#C29F6B' }}
            onClick={onSignup}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
              fontFamily="JosefinSans"
            >
              {t('lv_member_signup_btn')}
            </Text>
          </Button> */}
        </Box>
      </Box>
    </>
  );
};

export default LaValleShopFromHome;
